import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import About from "@/components/About";
import StickerGlow from "@/components/StickerGlow";
import Services from "@/components/Services";
import Products from "@/components/Products";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#FFFDF9] text-[#3B2A22] overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <Benefits />
        <About />
        <StickerGlow />
        <Services />
        <Products />
        <Gallery />
        <Testimonials />
        <FAQ />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
